module.exports = __webpack_public_path__ + "static/media/logo.9de9d031.png";


//////////////////
// WEBPACK FOOTER
// ./images/logo.png
// module id = 2790
// module chunks = 0